import {isCustomProperty} from 'cl-api';
import * as React from 'react';
import GeneralActions from '../../shared/ActionsManager/GeneralActions/GeneralActions';
import {GENERAL_ACTIONS_TYPES} from '../../shared/ActionsManager/ActionsTypes';
import connectWithRouter from '../../shared/components/redux/connectWithRouter';
import {ACTION_DISPLAY_TYPES} from '../../shared/ActionsManager/ActionsManagerConsts';
import EditVariationOptionsDialog, {
  aspectValuesType,
} from '../../shared/components/Dialogs/EditVariationOptionsDialog/EditVariationOptionsDialog';
import {SpecificFormDialogProps} from 'cl-dialogs/FormDialog';
import {getVariationSpecificsSet} from './EditProductSelectors';
import * as _ from 'lodash';
import {VARIATION_OPTIONS_FIELDS} from './consts';
import {FieldsInfo} from 'cl-form/FormSections/consts';

export interface ProductEditVariationOptionsDialogProps {
  initialVariationsSpecificSet?: aspectValuesType;
  fieldsInfo: FieldsInfo<any>;
}

export type ProductEditVariationOptionsDialogComputedProps = SpecificFormDialogProps<
  {},
  ProductEditVariationOptionsDialogProps
>;
const ProductEditVariationOptionsDialog: React.FunctionComponent<ProductEditVariationOptionsDialogComputedProps> = ({
  initialVariationsSpecificSet,
  fieldsInfo,
  ...other
}) => {
  const recommendedVariationSpecifics = React.useMemo(
    () =>
      _.reduce(
        [...VARIATION_OPTIONS_FIELDS, ..._.filter(_.map(fieldsInfo, 'name'), isCustomProperty)],
        (result, aspectName) => ({
          ...result,
          [aspectName]: {
            recommendations: _.map(
              _.get(_.find(fieldsInfo, field => field.name === aspectName), 'options'),
              value => value.value
            ),
          },
        }),
        {}
      ),
    []
  );

  return (
    <EditVariationOptionsDialog
      recommendedVariationSpecifics={recommendedVariationSpecifics}
      initialVariationsSpecificSet={initialVariationsSpecificSet}
      actions={
        <GeneralActions
          types={[GENERAL_ACTIONS_TYPES.EDIT_PRODUCT_VARIATION_OPTIONS]}
          displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
        />
      }
      formName={GENERAL_ACTIONS_TYPES.EDIT_PRODUCT_VARIATION_OPTIONS}
      aspectSelectProps={{creatable: false}}
      columns={_.mapKeys(fieldsInfo, ({name}) => name)}
      {...other}
    />
  );
};

export default connectWithRouter(
  state => ({
    initialVariationsSpecificSet: getVariationSpecificsSet(state),
  }),
  {}
)(ProductEditVariationOptionsDialog);
